<template>
  <div class="registry-wrap">
    <div id="registry">
      <div class="registry-log" v-if="showLog">
        <div class="registry-log-mask"></div>
        <div class="text">
          <p><span>40000+</span> 消费医疗与</p>
          <p>健康服务机构的选择</p>
        </div>
      </div>
      <div class="registry-content" :style="contentStyle">
        <div class="form-title">营销获客+经营管理一体化软件</div>
        <div class="form-tips">
          我们的顾问会为您提供获客留客以及全面节省运营成本的建议
        </div>
        <div class="form-content">
          <a-form
            autocomplete="off"
            :scrollToFirstError="true"
            :model="formState"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
            @finish="validateSuccess"
            @finishFailed="validateFail"
          >
            <a-form-item
              label="手机号"
              name="telephoneNumber"
              :rules="[{ required: true, message: '请输入手机号' }]"
            >
              <a-input
                placeholder="请输入手机号"
                v-model:value="formState.telephoneNumber"
                maxLength="11"
              />
            </a-form-item>
            <a-form-item
              label="验证码"
              name="registryCode"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <a-input
                placeholder="请输入验证码"
                v-model:value="formState.registryCode"
                maxLength="6"
              />
              <a-button
                type="link"
                class="btn-getcode"
                @click="getRegistryCode"
                >{{ btnText }}</a-button
              >
            </a-form-item>
            <div v-show="needSlide" id="nc"></div>
            <div v-if="isRegistry">
              <a-form-item
                label="机构名称"
                name="organization"
                :rules="[{ required: true, message: '请输入机构名称' }]"
              >
                <a-input
                  placeholder="请输入机构名称"
                  v-model:value="formState.organization"
                />
              </a-form-item>
              <a-form-item
                label="地区"
                name="area"
                :rules="[{ required: true, message: '请选择地区' }]"
              >
                <a-cascader
                  :options="options"
                  placeholder="请选择地区"
                  v-model:value="formState.area"
                  @change="areaChange"
                />
              </a-form-item>
              <a-form-item label="详细地址" name="address">
                <a-input
                  placeholder="请输入详细地址"
                  v-model:value="formState.address"
                />
              </a-form-item>
              <a-form-item label="称呼">
                <a-input
                  placeholder="请输入称呼"
                  v-model:value="formState.appellation"
                />
              </a-form-item>
            </div>
            <a-form-item
              :wrapper-col="{ span: 14, offset: 4 }"
              style="border: none"
            >
              <a-button
                class="btn-registry"
                type="primary"
                html-type="submit"
                :disabled="disabled"
                >立即申请</a-button
              >
            </a-form-item>
          </a-form>
        </div>
        <div class="form-consult">
          <p>
            <img class="qrcode" src="../../assets/qrcode.jpg" alt="咨询" />
          </p>
          <p>如果注册失败，您可以扫描添加顾问</p>
        </div>
      </div>
    </div>
    <div class="error-wrap" v-if="showError">
      <img src="../../assets/Warning.png" alt="warning" />
      <p class="title">申请失败</p>
      <p class="errormsg">{{ errorMsg }}</p>
      <img class="qrcode" src="../../assets/qrcode.jpg" alt="warning" />
      <p class="subtitle">如遇注册失败，您可以扫码添加顾问</p>
      <div class="close" @click="closeError"></div>
    </div>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import location from '../../data/location'
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  onUnmounted,
  computed
} from 'vue'
import { get, post } from '../../service/http'
import QS from 'qs'

export default defineComponent({
  name: 'Registry',
  components: {},
  setup() {
    let isRegistry = ref(false) // 补充信息展示标志位
    let needSlide = ref(false) // 是否展示滑块
    let btnText = ref('获取短信验证码') // countdown 按钮文本
    let options = ref(location) // 地区信息
    let showLog = ref(true) // 是否展示左半部分
    let showError = ref(false) // 是否展示错误弹窗
    let contentStyle = ref('') // content style
    let errorMsg = ref('') // 错误信息
    let interval = '' // 计时器
    let time = 60 // 倒计时
    let token = '' // token
    let parentUrl = '' // 父窗口url

    const ua = navigator.userAgent
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
      isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
      isAndroid = ua.match(/(Android)\s+([\d.]+)/),
      isMobile = isIphone || isAndroid

    onMounted(() => {
      document.body.style.backgroundColor = '#fbfbfb'
      // 接收parent消息
      window.addEventListener(
        'message',
        function (event) {
          const parentData = event.data
          parentUrl = parentData.url || ''
        },
        false
      )
      if (isMobile) {
        showLog.value = false
      } else {
        showLog.value = true
      }

      // 倒计时
      time = +localStorage.getItem('leftTime') || 60
      // 如果没有倒计时结束 则继续倒计时
      if (time > 0 && time < 60) {
        countDown()
      }

      // 获取token
      getToken()

      // 初始化滑块
      slideInit()
    })

    onUnmounted(() => {
      document.body.style.backgroundColor = '#fff'
    })

    // 提交按钮禁用
    const disabled = computed(() => {
      const mobileReg = /^1\d{10}$/
      let ret = true
      // 没展开 只校验手机号和验证码
      if (!isRegistry.value) {
        ret = !(
          mobileReg.test(formState.telephoneNumber) && formState.registryCode
        )
      } else {
        // 展开后 校验全部必填字段
        ret = !(
          mobileReg.test(formState.telephoneNumber) &&
          formState.registryCode &&
          formState.organization &&
          formState.area &&
          formState.area.length
        )
      }
      return ret
    })
    // 加载滑块
    const slideInit = function () {
      // 初始化nc滑块
      window.AWSC.use('nc', function (state, module) {
        // 初始化
        window.nc = module.init({
          appkey: 'FFFF0N0N00000000A2AE',
          scene: 'nc_login_h5',
          // 声明滑动验证需要渲染的目标ID。
          renderTo: 'nc',
          width: 275,
          upLang: {
            cn: {
              // 加载状态提示。
              LOADING: '滑动解锁加载中...',
              // 等待滑动状态提示。
              SLIDE: '向右滑动解锁获取验证码',
              // 验证通过状态提示。
              SUCCESS: '验证通过',
              // 验证失败触发拦截状态提示。
              ERROR: '非常抱歉，网络出错了...',
              // 验证失败触发拦截状态提示。
              FAIL: '验证失败，请重试'
            }
          },
          // test: module.TEST_PASS,
          // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          success: function () {
            window.nc.reset()
            needSlide.value = false
            getSMS()
          },
          // 滑动验证失败时触发该回调参数。
          fail: function (failCode) {
            window.nc.reset()
          },
          // 验证码加载出现异常时触发该回调参数。
          error: function (errorCode) {
            window.nc.reset()
          }
        })
      })
      //
      window.AWSC.use('nvc', function (state, module) {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({
          appkey: 'FFFF0N0N00000000A2AE',
          scene: 'nvc_message',
          // test: module.TEST_NC_PASS,
          success: function (data) {},
          // 前端二次验证失败时触发该回调参数
          fail: function (failCode) {},
          // 前端二次验证加载异常时触发该回调参数。
          error: function (errorCode) {}
        })
      })
    }
    const formState = reactive({
      telephoneNumber: '',
      registryCode: '',
      organization: '',
      area: '',
      address: '',
      appellation: ''
    })
    const validateSuccess = (values) => {
      if (isRegistry.value) {
        const url = parentUrl || getParentUrl()
        const queries = parseUrl(url)
        const requestBody = {
          SourceCode: queries.source || '', // 线索来源
          SourceDetail1: queries.e_keywordid ? '付费推广' : '自然流量', // 细分来源
          ContactName: values.appellation, // 客户联系人
          CustomerName: values.organization, // 诊所/机构名称
          MobilePhone: values.telephoneNumber, // 联系人手机号
          Province: values.area[0], // 省，例如北京市
          City: values.area[1], // 城，例如北京市
          authCode: values.registryCode, // 验证码
          Address: values.address, // 地址
          KeyWord: queries.e_keywordid, //百度搜素关键字id
          EntityType: '5067108', // 业务类型编码 口腔：3095150，医美：5067108，其他：3095150
          ClientType: isMobile ? '手机' : '电脑',
          clientIP: '' // 前端无法精确拿到客户端ip地址
        }
        post('/Leads', requestBody, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
          .then(function (response) {
            console.log(response)
            if (response.result.success) {
              message.success('注册成功')
            } else {
              if (isMobile) {
                message.error(response.result.message)
              } else {
                errorMsg.value = response.result.message
                showError.value = true
              }
            }
          })
          .catch(function (error) {})
      } else {
        isRegistry.value = true
      }
    }

    const validateFail = (errorInfo) => {
      if (!isRegistry.value) {
        isRegistry.value = true
      }
      console.log('Failed:', errorInfo)
    }
    // 获取token
    const getToken = function () {
      get('/token?account=marketregister&password=register@123')
        .then(function (res) {
          token = res.result.token
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    // 获取查询对象
    const parseUrl = function (url) {
      url = url || window.location.href
      const startPoint = url.indexOf('?') + 1
      const endPoint = url.length
      const urlSegment = url.slice(startPoint, endPoint)
      const kvArr = urlSegment.split('&')
      return kvArr.reduce(function (prev, curr) {
        const kv = curr.split('=')
        prev[kv[0]] = kv[1]
        return prev
      }, {})
    }
    // 获取父页面url
    const getParentUrl = function () {
      let url = ''
      try {
        url = window.top.document.referrer
      } catch (M) {
        if (window.parent) {
          try {
            url = window.parent.document.referrer
          } catch (L) {
            url = ''
          }
        }
      }
      if (url === '') {
        url = document.referrer
      }
      return url
    }
    // 点击获取验证码handle
    const getRegistryCode = function () {
      if (time === 60) {
        const mobilReg = /^1\d{10}$/
        if (mobilReg.test(formState.telephoneNumber)) {
          // 显示滑块
          needSlide.value = true
        } else {
          message.error('请输入正确的手机号')
        }
      }
    }
    // 获取短信验证码
    const getSMS = function () {
      window.nvc.getNVCValAsync(function (nvcVal) {
        post(
          'shortmessage/sendmsg',
          QS.stringify({
            nvcVal,
            phoneNumber: formState.telephoneNumber
          })
        )
          .then(function (response) {
            if (response.result.success) {
              message.success('发送成功')
              isRegistry.value = true
              countDown()
            } else {
              message.error(response.result.message)
            }
          })
          .catch(function (error) {})
      })
    }
    // 倒计时
    const countDown = function () {
      interval = setInterval(() => {
        if (time > 0) {
          time--
          btnText.value = `${time}s`
          localStorage.setItem('leftTime', time)
        } else {
          time = 60
          clearInterval(interval)
          btnText.value = '重新获取'
          localStorage.removeItem('leftTime')
        }
      }, 1000)
    }
    // 跳转登录
    const goLogin = function () {
      if (/^https/.test(parentUrl)) {
        window.top.postMessage(
          {
            event: 'jump',
            jumpUrl: 'https://em.linkedcare.cn'
          },
          'https://meiye.linkedcare.cn'
        )
      } else {
        window.top.postMessage(
          {
            event: 'jump',
            jumpUrl: 'https://em.linkedcare.cn'
          },
          'http://meiye.linkedcare.cn'
        )
      }
    }
    // 关闭错误弹窗
    const closeError = function () {
      showError.value = false
    }
    return {
      validateSuccess,
      validateFail,
      getRegistryCode,
      goLogin,
      closeError,
      formState,
      isRegistry,
      needSlide,
      btnText,
      options,
      showLog,
      contentStyle,
      showError,
      errorMsg,
      disabled
    }
  }
})
</script>
<style lang="less">
.registry-wrap {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fbfbfb;
  #registry {
    position: relative;
    margin: 0 auto;
    height: auto;
    min-height: 636px;
    display: flex;
    border-radius: 12px;
    background: white;
    .registry-log {
      width: 323px;
      position: relative;
      img {
        width: 300px;
        height: 558px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .registry-log-mask {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
        background-color: #845cf8;
        opacity: 0.6;
        border-radius: 12px 0px 0px 12px;
      }
      .text {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        z-index: 11;
        p {
          margin: 0;
          font-family: SourceHanSansCN-Bold;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0.64px;
        }
        span {
          font-size: 30px;
          font-weight: Bold;
        }
      }
    }
    .registry-content {
      height: auto;
      min-height: 636px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      border-radius: 0px 12px 12px 0px;
      padding: 48px;
      box-sizing: border-box;
      position: relative;

      .form-title {
        font-size: 22px;
        line-height: 30px;
        color: #845cf8;
        text-align: center;
        font-weight: 600;
        margin-bottom: 8px;
      }
      .form-tips {
        font-size: 12px;
        color: #595959;
        line-height: 17px;
        text-align: center;
        margin-bottom: 30px;
      }
      .form-content {
        .ant-form-item {
          margin-bottom: 14px;
          border-bottom: 1px solid #e6e6e6;
          position: relative;
        }
        .ant-form-item-label {
          text-align: left;
        }
        input {
          border: none;
        }
        .btn-getcode {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          color: #845cf8;
        }
        .btn-registry {
          width: 331px;
          height: 43px;
          font-size: 18px;
          border-radius: 4px;
          margin: 0 auto;
          background-image: linear-gradient(130deg, #af7cfe 0%, #a2abff 100%);
          transform: translate(-17%, 30%);
          border: none;
        }
        .btn-registry:disabled {
          color: #fff;
          opacity: 0.2;
        }
      }
      .form-login {
        text-align: center;
        line-height: 20px;
        font-size: 15px;
        button {
          padding: 0;
          color: #845cf8;
        }
      }
    }
    .form-consult {
      margin-top: 25px;
      p {
        text-align: center;
        font-size: 10px;
      }
      .qrcode {
        width: 71px;
        height: 70px;
      }
    }
  }
  .error-wrap {
    position: absolute;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 424px;
    height: 321px;
    padding: 28px 0;
    background: #ffffff;
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .title {
      margin: 11px 0 0 0;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
    .errormsg {
      margin: 8px 0 20px 0;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
      line-height: 22px;
    }
    .qrcode {
      width: 99px;
      height: 98px;
    }
    .subtitle {
      margin-top: 4px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 10px;
      color: #000000;
    }
    img {
      width: 64px;
      height: 64px;
    }

    .close {
      position: absolute;
      right: 17.5px;
      top: 17.5px;
      width: 32px;
      height: 32px;
      cursor: pointer;
    }
    .close:before,
    .close:after {
      position: absolute;
      left: 25px;
      content: ' ';
      height: 11px;
      width: 2px;
      background-color: #333;
    }
    .close:before {
      transform: rotate(45deg);
    }
    .close:after {
      transform: rotate(-45deg);
    }
  }
}
.nc-container {
  position: relative !important;
  font-size: 18px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
  .nc_1_nocaptcha {
    width: 100% !important;
    height: 100% !important;
    .nc_wrapper {
      width: 100% !important;
      height: 100% !important;
      display: flex;
      justify-content: center;
      align-items: center;
      .nc_scale {
        width: 300px !important;
        height: 40px !important;
        font-size: 12px;
        .btn_slide {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
        .scale_text.slidetounlock span[data-nc-lang='SLIDE'] {
          height: 40px;
          line-height: 40px;
        }
        .btn_ok {
          color: #845cf8 !important;
          height: 40px !important;
          line-height: 40px !important;
        }
        .nc_ok,
        .nc_bg {
          background: #845cf8 !important;
        }
        span.nc-lang-cnt {
          line-height: 40px !important;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
